import {
  Button,
  Col,
  Modal,
  Row,
  Select,
  Steps,
  Upload,
  notification,
} from 'antd'
import './ModalUploadOrder.style.less'
import { useState } from 'react'
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseCircleFilled,
  CloudUploadOutlined,
  FileExcelOutlined,
} from '@ant-design/icons'
import { useMutation, useQuery } from 'react-query'
import {
  downloadOrderTemplateExcel,
  getOrderTemplate,
  uploadOrderExcel,
} from '@/screens/Order/Pages/Order.transform'
import { JSONStringify, isEmptyValue } from '@/utils/common'
import LoadingFingertip from '@/components/LoadingFingertip/LoadingFingertip'
import { saveOrderExcel } from '@/utils/filesaver'

interface Props {
  visible: boolean
  onClose: () => void
  data: any
  onSave: (data: any) => void
}

function ModalUploadOrder(props: Props) {
  const [current, setcurrent] = useState(0)
  const [selectedTemplate, setselectedTemplate]: any = useState(null)
  const [uploadResult, setuploadResult] = useState(true)
  const [file, setfile] = useState(null)
  const [erroMessage, seterroMessage] = useState('')
  const [resultNumber, setresultNumber] = useState(null)

  const [successFiles, setsuccessFiles] = useState(null)

  const steps = [
    {
      title: 'Download Template',
    },
    {
      title: 'Upload File',
    },
    {
      title: !uploadResult ? 'Error' : 'Done',
    },
  ]

  const uploadMutation = useMutation(async () => {
    return await uploadOrderExcel(file, selectedTemplate.id)
  }, {})

  const { data: templates, isLoading }: any = useQuery(
    ['GET_ORDER_TEMPLATES'],
    async () => {
      const payload = {}
      return await getOrderTemplate(payload)
    }
  )

  const onDownloadFile = () => {
    saveOrderExcel(
      successFiles,
      `order-template-${templateName()}-import-processed`
    )
  }

  const templateName = () => {
    return templates?.find((item) => item.id == selectedTemplate.id)?.name
  }

  const onClickNext = async () => {
    setsuccessFiles(null)
    if (current == 2) return
    if (current == 1) {
      if (isEmptyValue(file)) {
        notification.error({ message: 'No file Selected', duration: 3 })
        return
      }
      const data: any = await uploadMutation.mutateAsync()

      if (data?.status == 400) {
        const json = JSON.parse(new TextDecoder().decode(data.data))
        seterroMessage(json?.message)
        setuploadResult(false)
      } else {
        setsuccessFiles(new Blob([data.data]))
        setresultNumber(JSON.parse(data?.headers['x-result-number']))
        seterroMessage('')
        setuploadResult(true)
      }
    }
    setcurrent(current + 1)
  }

  const onPrevious = () => {
    if (current == 0) return
    setcurrent(current - 1)
    setresultNumber(null)
  }

  const downloadMutation = useMutation(async () => {
    await downloadOrderTemplateExcel({
      template_id: selectedTemplate.id,
      name: `order-template-${templateName()}`,
    })
    return
  })

  return (
    <Modal
      open={props.visible}
      onCancel={props.onClose}
      width={640}
      maskClosable={false}
      footer={false}
      closable={!uploadMutation.isLoading}
      className="modal-step-upload-order"
    >
      <div>
        <p className="modal-dialog-title">Import Orders</p>
        <Steps
          current={current}
          items={steps}
          status={
            current == 2 && !uploadResult
              ? 'error'
              : current == 1 || current == 0
              ? 'process'
              : 'finish'
          }
        />
        <div style={{ minHeight: 200 }}>
          {current == 0 ? (
            <div className="step-content-container">
              <Row align={'middle'}>
                <p className="select-title">Order Info Template</p>
                <Col span={17}>
                  <Select
                    onChange={(value) => {
                      setselectedTemplate(
                        !isEmptyValue(value) ? JSON.parse(value) : null
                      )
                    }}
                    loading={isLoading}
                    allowClear
                    showSearch
                    options={templates?.map((item) => {
                      return {
                        label: item.name,
                        value: JSONStringify({
                          id: item.id,
                          name: item?.name,
                        }),
                      }
                    })}
                    value={
                      !isEmptyValue(JSONStringify(selectedTemplate))
                        ? JSONStringify(selectedTemplate)
                        : null
                    }
                    className="select-select"
                    placeholder="Select template to download in Excel"
                  />
                </Col>
              </Row>
              {!isEmptyValue(selectedTemplate) && (
                <div className="button-download-template-container">
                  <p>
                    Download the Excel template and fill in your data for up to
                    <span style={{ fontWeight: 600 }}> 50 orders</span>. Make
                    sure that{' '}
                    <span style={{ fontWeight: 600 }}>
                      mandatory fields (*)
                    </span>{' '}
                    are filled in for each order.
                  </p>
                  <Button
                    onClick={() => downloadMutation.mutate()}
                    disabled={downloadMutation.isLoading}
                  >
                    <FileExcelOutlined />
                    <p>Download Excel Template</p>
                  </Button>
                </div>
              )}
            </div>
          ) : current == 1 ? (
            uploadMutation.isLoading ? (
              <div className="step-content-container">
                <div className="fingertip-loading-container ">
                  <LoadingFingertip loading />
                  <div className="content">
                    <p className="content-title">Importing Orders...</p>
                    <p className="content-sub-title">
                      Please wait until the import is completed.
                    </p>
                    <p>
                      New orders are being created from your data. If it
                      contains errors, you will get the details back in the file
                      to correct them.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="step-content-container">
                <p>
                  Upload the Excel template{' '}
                  <span style={{ fontWeight: 600 }}>{templateName()}</span> with
                  your data filled in.
                </p>
                <Upload.Dragger
                  name="files"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  action="/upload.do"
                  maxCount={1}
                  beforeUpload={(files) => {
                    setfile(files)
                    return false
                  }}
                  onRemove={() => setfile(null)}
                >
                  <p className="ant-upload-drag-icon">
                    <CloudUploadOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                </Upload.Dragger>
              </div>
            )
          ) : uploadResult ? (
            <div className="center-container">
              {resultNumber?.fail == 0 ? (
                <>
                  <Row align={'middle'} className="success-container">
                    <CheckCircleFilled style={{ color: '#65BF73' }} />
                    <p className="success-title">Success!</p>
                  </Row>
                  <p className="success-descrption-count">
                    {resultNumber?.success} new orders have been created.
                  </p>
                  <p className="success-descrption">
                    You can now access and review them.
                  </p>
                </>
              ) : (
                <>
                  <Row align={'middle'} className="success-container">
                    <CheckCircleOutlined style={{ color: '#4a8dc0' }} />
                    <p className="success-title">Import Completed</p>
                  </Row>
                  <Row align={'middle'} style={{ marginBottom: 15 }}>
                    <CheckCircleFilled
                      style={{ color: '#65BF73', fontSize: 18 }}
                    />
                    <p className="success-descrption-count">
                      {resultNumber?.success} new orders have been created.
                    </p>
                  </Row>
                  <Row align={'middle'}>
                    <CloseCircleFilled
                      style={{ color: '#C03261', fontSize: 18 }}
                    />
                    <p className="success-descrption-count">
                      {resultNumber?.fail} orders could not be created.
                    </p>
                  </Row>
                  <p className="success-descrption" style={{ width: '89%' }}>
                    Please{' '}
                    <span
                      className="click-download-link"
                      onClick={onDownloadFile}
                    >
                      click here to download
                    </span>{' '}
                    the file and correct the errors
                  </p>
                </>
              )}
            </div>
          ) : (
            <div className="center-container">
              <Row align={'middle'} className="success-container">
                <CloseCircleFilled style={{ color: '#C03261' }} />
                <p className="success-title">Oops!</p>
              </Row>
              {!isEmptyValue(erroMessage) ? (
                <>
                  <p className="success-descrption">
                    Your file contains errors and could not be imported.
                  </p>
                  <p className="success-descrption" style={{ fontWeight: 600 }}>
                    {erroMessage}
                  </p>
                  <p className="success-descrption">
                    Please check the file and try again.
                  </p>
                </>
              ) : (
                <p className="success-descrption">
                  An error has occurred. Please check your file and try again.
                </p>
              )}
            </div>
          )}
        </div>

        {resultNumber?.fail > 0 ? (
          <Row className="stepper-button">
            {current == 2 && !uploadResult && (
              <Button
                size="large"
                className="prev-button"
                onClick={props.onClose}
              >
                Cancel
              </Button>
            )}
            <Button
              size="large"
              type="primary"
              className="next-button"
              onClick={() => {
                setfile(null)
                onPrevious()
              }}
            >
              Try Again
            </Button>
          </Row>
        ) : (
          <Row className="stepper-button">
            {current != 2 && current != 0 && !uploadMutation.isLoading && (
              <Button
                size="large"
                className="prev-button"
                onClick={onPrevious}
                disabled={uploadMutation.isLoading}
              >
                Previous
              </Button>
            )}
            {current == 2 && !uploadResult && (
              <Button
                size="large"
                className="prev-button"
                onClick={props.onClose}
              >
                Close
              </Button>
            )}
            {current == 2 && uploadResult && (
              <Button
                size="large"
                type="primary"
                className="next-button"
                onClick={() => {
                  props.onClose()
                }}
              >
                Close
              </Button>
            )}
            {current != 2 && !uploadMutation.isLoading && (
              <Button
                size="large"
                type="primary"
                className="next-button"
                onClick={onClickNext}
                disabled={
                  uploadMutation.isLoading || isEmptyValue(selectedTemplate)
                }
              >
                Next
              </Button>
            )}
            {!uploadResult && current == 2 && (
              <Button
                size="large"
                type="primary"
                className="next-button"
                onClick={() => {
                  setfile(null)
                  onPrevious()
                }}
              >
                Try Again
              </Button>
            )}
          </Row>
        )}
      </div>
    </Modal>
  )
}

export default ModalUploadOrder
